import React from 'react';
import { ArrowLeft } from 'lucide-react';

interface DetailViewContainerProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
    rightAction?: React.ReactNode;
}

export const DetailViewContainer: React.FC<DetailViewContainerProps> = React.memo(({ 
    title, 
    onClose, 
    children, 
    rightAction 
}) => {
    return (
        <div className="bg-white animate-in slide-in-from-right duration-300 min-h-screen">
            <header className="sticky top-0 z-[70] h-[65px] border-b border-gray-100 px-4 flex items-center justify-between bg-white/95 backdrop-blur-md">
                <div className="flex items-center gap-6 min-w-0">
                    <button 
                        onClick={onClose} 
                        className="w-10 h-10 flex items-center justify-center md:hover:bg-gray-100 rounded-full transition-all active:scale-90 text-slate-900 shrink-0"
                    >
                        <ArrowLeft size={22} strokeWidth={2.5} />
                    </button>
                    <div className="flex flex-col min-w-0">
                        <h2 className="text-xl font-black text-slate-900 tracking-tight uppercase leading-none truncate">{title}</h2>
                    </div>
                </div>
                {rightAction && (
                    <div className="shrink-0">
                        {rightAction}
                    </div>
                )}
            </header>
            <div className="p-0 bg-white">
                <div className="max-w-[700px] mx-auto min-h-full">
                    {children}
                </div>
            </div>
        </div>
    );
});

DetailViewContainer.displayName = 'DetailViewContainer';
